import type { FC } from 'react'
import { ShopModel } from '~/models'
import { Item } from '~/components/text'

type DetailProps = {
  shop: ShopModel
}

export const Detail: FC<DetailProps> = ({ shop }) => {

  return (
    <>
      <div className="flex flex-row items-baseline border-b border-gray-300 gap-2">
        <h3 className="shrink-0 basis-3/12 md:basis-2/12 text-xs font-medium text-gray-500 mt-auto">住所</h3>
        <p className="break-all mt-auto">
          <span className="">
            {shop.address.postalCode.format()}
          </span>
          <span className="ml-2">
            {shop.address.prefectureCode.getDisplayName()}
            {shop.address.city}
            {shop.address.address1}
            {shop.address.address2}
            {shop.address.building}
          </span>
        </p>
      </div>
      <div className="mt-4 flex flex-row items-baseline border-b border-gray-300 gap-2">
        <h3 className="shrink-0 basis-3/12 md:basis-2/12 text-xs font-medium text-gray-500 mt-auto">電話番号</h3>
        <p className="break-all mt-auto">{shop.contact.phoneNumber.format()}</p>
      </div>
    </>
  )
}
